import { Container, LoadingText, Spinner } from './styles';

/** `text` nulo deixa só o giro, para quem já anuncia o carregamento por perto. */
const LoadingIndicator = ({ text = 'Carregando...' }) => (
  <Container>
    <Spinner />
    {text && <LoadingText>{text}</LoadingText>}
  </Container>
);

export default LoadingIndicator;
